module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 046.a5869617.jpg";